/** True for a normal primary-button navigation (not modified / middle / secondary click). */
export function isPlainLeftClick(event) {
  return (
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}

function toURLSearchParams(searchParams) {
  if (!searchParams) return new URLSearchParams();
  if (typeof searchParams === 'string') return new URLSearchParams(searchParams);
  return new URLSearchParams(searchParams.toString());
}

export function workspacePath(workspaceId, searchParams) {
  const base = `/workspace/${workspaceId}`;
  if (!searchParams) return base;
  const qs =
    typeof searchParams === 'string'
      ? searchParams
      : searchParams.toString();
  return qs ? `${base}?${qs}` : base;
}

export function workspaceNewChatPath(workspaceId, searchParams) {
  const params = toURLSearchParams(searchParams);
  params.delete('chat');
  return workspacePath(workspaceId, params);
}

export function workspaceChatPath(workspaceId, chatId, searchParams) {
  const params = toURLSearchParams(searchParams);
  params.set('chat', chatId);
  return workspacePath(workspaceId, params);
}
